import {API_URL, getHeaders, getPromise} from '../model-manager';
import {SessionManager} from '../session-manager';

export class UserModelManager {

    /**
     * Get connected user.
     *
     * @returns {Promise}
     */
    static getConnectedUser(slug = null) {
        const url = `${API_URL}/api/users/me`;

        return getPromise(url, {headers: getHeaders(false)}, false, false);
    }

    /**
     * confirm user.
     *
     * @returns {Promise}
     */
    static confirmUser(confirmationToken, slug = null) {
        const url = `${API_URL}/active/${confirmationToken}`;

        return getPromise(url, {headers: getHeaders(false)}, false, false);
    }

    static login(username, password, slug = null) {
        const API_URL = import.meta.env.VITE_BASE_URL || '';

        const init = {
            headers: getHeaders(true),
            method: 'POST',
            body: JSON.stringify({email: username, password: password}),
        };

        return fetch(`${API_URL}/login`, init)
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }

                return response.json();
            })
            .then(data => {
                // login successful if there's a jwt token in the response
                localStorage.setItem(SessionManager.getTokenKey(), data.token);
                SessionManager.setExpired(false);

                return data;
            });

    }

}